import React, { useEffect } from 'react';
import { IoMdCheckmark } from 'react-icons/io';

import './style.scss';

// Definição do tipo Step
interface Step {
    id: number;
    label: string;
    completed: boolean;
    subSteps: number;
    currentSubStepActive: number;
}

const steps: Array<Step> = [
    {
        id: 1,
        label: 'Inscrição',
        completed: true,
        subSteps: 3,
        currentSubStepActive: 0
    },
    {
        id: 2,
        label: 'Etapa 1 <br />de avaliação',
        completed: false,
        subSteps: 1,
        currentSubStepActive: 0
    },
    {
        id: 3,
        label: 'Etapa 2 <br />de avaliação',
        completed: false,
        subSteps: 3,
        currentSubStepActive: 0
    },
    {
        id: 4,
        label: 'Etapa 3 <br />de avaliação',
        completed: false,
        subSteps: 2,
        currentSubStepActive: 0
    },
    {
        id: 5,
        label: 'Resultado',
        completed: false,
        subSteps: 1,
        currentSubStepActive: 0
    }
];

interface Options {
    currentStep: number;
    activeSubStep?: number;
}

const StepNav = ({ currentStep, activeSubStep = 1 }: Options) => {
    const totalSubSteps = steps.reduce((acc, step) => acc + step.subSteps, 0);

    const currentPosition = steps.slice(0, currentStep).reduce((acc, step) => acc + step.subSteps, 0) + activeSubStep;

    const progress = (currentPosition / totalSubSteps) * 100;

    return (
        <div className="relative flex items-center justify-between step">
            {steps.map((step, index) => (
                <>
                    <div key={index} className={`relative z-10 items-center flex step-item ${index !== steps.length - 1 ? 'flex-1' : ''}`}>
                        <div className={`step-bullet ${step.id <= currentStep ? 'active' : 'inactive'}`}>{step.id}</div>
                        {step.subSteps > 0 && (
                            <div className={`flex relative items-center flex-1 px-4 substeps ${step.subSteps <= 2 ? 'justify-evenly' : 'justify-between'}`}>
                                {Array.from({ length: step.subSteps }).map((_, subIdx) => (
                                    <div
                                        key={subIdx}
                                        className={`substep-dot relative z-10 text-xs flex items-center justify-center ${
                                            (subIdx <= activeSubStep && step.id <= currentStep) || step.completed ? 'active text-white' : ''
                                        }`}
                                    >
                                        {(subIdx <= activeSubStep && step.id <= currentStep) || step.completed ? <IoMdCheckmark /> : <></>}
                                    </div>
                                ))}

                                <div className="absolute left-0 w-full h-[1.5px] top-[50%] bg-[#D4D8DD]">
                                    {step.id <= currentStep && <div className="inner bg-blue-bb h-[1px]" style={{ width: `${step.completed ? 100 : progress}%` }}></div>}
                                </div>
                            </div>
                        )}

                        <p
                            className={`step-label ${step.id === currentStep || step.completed ? 'active' : ''} ${step.label.split(' ').length > 1 ? 'is-left' : ''} text-center`}
                            dangerouslySetInnerHTML={{ __html: step.label }}
                        ></p>
                    </div>
                </>
            ))}
        </div>
    );
};

export default StepNav;
